import React from 'react';

const SmileDesignLogo: React.FC = () => {
    return (
        <div className="relative w-full h-full flex items-center justify-center overflow-hidden">
            {/* 
               The original design is w-48 (12rem = 192px). 
               The sidebar icon container is roughly w-10 (2.5rem = 40px).
               Scale factor: 40 / 192 ≈ 0.21.
               We use a fixed scale wrapper to preserve the exact look of the large CSS shapes.
            */}
            <div
                className="transform scale-[0.2] origin-center shrink-0"
                style={{ width: '192px', height: '192px' }}
            >
                <div className="relative w-full h-full flex items-center justify-center">

                    {/* Outer Smile Line */}
                    <div
                        className="absolute w-full h-full border-b-[6px] border-teal-500 rounded-full"
                        style={{ boxShadow: '0 0 10px #14b8a6' }}
                    ></div>

                    {/* Middle Smile Line */}
                    <div
                        className="absolute w-3/4 h-3/4 border-b-[10px] border-teal-500/70 rounded-full"
                        style={{ boxShadow: '0 0 15px #14b8a6' }}
                    ></div>

                    {/* Inner Smile Line */}
                    <div
                        className="absolute w-1/2 h-1/2 border-b-[14px] border-teal-500/40 rounded-full"
                        style={{ boxShadow: '0 0 20px #14b8a6' }}
                    ></div>

                </div>
            </div>
        </div>
    );
};

export default SmileDesignLogo;
